/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { OrderConstants } from '../actions/actionType';

export function OrderData(state = {}, action) {
    switch (action.type) {
    case OrderConstants.GET_ORDER_DETAILS_REQUEST:
        return {
            type: OrderConstants.GET_ORDER_DETAILS_REQUEST,
            message: action.message,
        };
    case OrderConstants.GET_ORDER_DETAILS_SUCCESS:
        return {
            type: OrderConstants.GET_ORDER_DETAILS_SUCCESS,
            order: action.user.data.data,
        };
    case OrderConstants.GET_ORDER_DETAILS_FAILURE:
        return {
            type: OrderConstants.GET_DISTRIBUTORS_SUCCESS,
            message: action.message,
        };
        
    default:
        return state;
    }
}
